export const ACTION_EINVOICE_LOG_STATUS = {
  ISSUE_INVOICE_WITHOUT_SIGNATURE: 'mn_action_add_invoice',
  CREATE_DRAFT_INVOICE:'mn_action_draft_invoice',
  EDIT_UNSIGNED_INVOICE: 'mn_action_edit_invoice',
  DELETE_UNSIGNED_INVOICE: 'mn_action_delete_invoice',
  //ISSUE_AND_SIGN_INVOICE: 'mn_action_issue_the_invoice',
  REPLACE_SIGNED_INVOICE: 'mn_action_replace_invoice',
  ADJUST_SIGNED_INVOICE: 'mn_action_adjust_invoice',
  // INCREASE_PRODUCT_PRICE_IN_SIGNED_INVOICE: 'mn_action_increase_adjustment',
  // DECREASE_PRODUCT_PRICE_IN_SIGNED_INVOICE: 'mn_action_decrease_adjustment',
  //ADJUST_INFOR_INVOICE: 'mn_action_adjust_information',
  SIGN_INVOICE: 'mn_action_sign_invoice'
}